export default __webpack_public_path__ + "media/titles/title_6_locale_sv-3d9764de.png";